import type { CSSObject, Theme } from '@mui/material'
import { styled, Typography } from '@mui/material'
import type { ElementType } from 'react'

export type SectionLabelColor = 'primary' | 'secondary' | 'disabled' | 'inherit'

/**
 * The single uppercase eyebrow token. The review found four sizes
 * (1.2 / 1.29 / 1.35 / 1.4rem) at four tracking values (0.04 / 0.06 / 0.07 /
 * 0.08em) across card titles, rail headings, timeline groups and list
 * sub-heads. This is the one that survives — subtitle2 at 0.07em, bold.
 * Nothing but the colour may vary between call sites.
 */
export const sectionLabelStyles = (theme: Theme): CSSObject => ({
  ...theme.typography.subtitle2,
  fontWeight: theme.typography.fontWeightBold,
  letterSpacing: '0.07em',
  lineHeight: 1.4,
  textTransform: 'uppercase',
})

export const Root = styled(Typography, {
  shouldForwardProp: (propName: PropertyKey) => propName !== 'labelColor',
})<{ component?: ElementType; labelColor: SectionLabelColor }>(({ theme, labelColor }) => ({
  ...sectionLabelStyles(theme),
  color:
    labelColor === 'inherit'
      ? 'inherit'
      : labelColor === 'primary'
        ? theme.palette.text.primary
        : labelColor === 'disabled'
          ? theme.palette.text.disabled
          : theme.palette.text.secondary,
}))
